import React from 'react'
import { csx, useBreakpoint } from '@vtex/admin-ui'

import { ProductImage } from '../../../../core/components'
import { useSelectedSkuLowResolutionImages } from './hooks'
import { SKU_THUMBNAILS_ITEMS_LIMIT } from './constants'

export const ProductSkuImageLoading = () => {
  const selectedSkuLowResolutionImages = useSelectedSkuLowResolutionImages()

  const { breakpoint } = useBreakpoint()
  const isMobileOrTablet = ['mobile', 'tablet'].includes(breakpoint)

  if (isMobileOrTablet) {
    return (
      <ProductImage src={selectedSkuLowResolutionImages[0]} alt="Loading..." />
    )
  }

  const slicedSkuThumbnails = selectedSkuLowResolutionImages.slice(
    0,
    SKU_THUMBNAILS_ITEMS_LIMIT
  )

  return (
    <>
      <div
        className={csx({
          display: 'grid',
          gap: '$space-3',
          alignContent: 'flex-start',
        })}
      >
        {slicedSkuThumbnails.map((thumbnail, index) => (
          <ProductImage
            key={thumbnail}
            src={thumbnail}
            alt=""
            className={csx({
              cursor: 'pointer',
              borderRadius: '4px',
              border: index === 0 ? '$mainSelected' : 'none',
            })}
          />
        ))}
      </div>
      <ProductImage src={selectedSkuLowResolutionImages[0]} alt="Loading..." />
    </>
  )
}
